import * as types from '../actions/dialog/types';

const INITIAL_STATE = {
  cancelLabel: '',
  content: '',
  error: false,
  okLabel: '',
  open: false,
  title: '',
};

export default function(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.CONFIRM_DIALOG:
      return action.payload;

    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confirmDialogReducer.js